import { IconFont, Menu } from '@byecode/ui'
import React, { useState } from 'react'
import styled from 'styled-components'

import type { CreatePagePayload } from '@/atoms/page/types'
import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'

import * as CM from '../style'
import type { PageKindType } from '../types'

interface CreatePageProps {
    withinPortal?: boolean
    targetComponent?: React.ReactNode
    groupId?: string
    onAdd: (v: CreatePagePayload) => void
}

const SCxTarget = styled.div`
    display: flex;
    align-items: center;

    ${CM.Icon} {
        color: var(--color-gray-500);
    }

    &:hover {
        ${CM.Icon} {
            color: var(--color-black);
        }
    }
`

export const CreatePage: React.FunctionComponent<CreatePageProps> = ({ withinPortal = true, groupId, targetComponent, onAdd }) => {
    const [menuOpened, setMenuOpened] = useState(false)

    return (
        <Menu
            opened={menuOpened}
            position="bottom-start"
            offsetOptions={{
                mainAxis: -2
            }}
            onChange={setMenuOpened}
            withinPortal={withinPortal}
            closeOnItemClick
            width={200}
        >
            <Menu.Target>
                {targetComponent ?? (
                    <SCxTarget>
                        <CM.Icon type="Add2" size={22} color="var(--color-gray-400)" />
                    </SCxTarget>
                )}
            </Menu.Target>
            <Menu.Dropdown onClick={e => e.stopPropagation()}>
                <Menu.Item
                    icon={<IconFont type="PageBroadContent" size={16} color="var(--color-gray-400)" />}
                    onClick={() => onAdd({ name: '新的页面', type: 'COMMON', groupId })}
                >
                    添加页面
                </Menu.Item>
                <Menu.Item
                    icon={<IconFont type="Folder" size={16} color="var(--color-theme-7)" />}
                    onClick={() => onAdd({ name: '新的分组', type: 'GROUP', groupId })}
                >
                    添加页面分组
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
}
